import styled from '@emotion/styled';
import { Box, themeGet } from '@lightspeed/flame/Core';

export const StyledBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 3px;
  &:hover {
    background-color: ${themeGet(`colors.${'maple-500'}`)};
  }
`;
